import script from "./UserAccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountPage.vue?vue&type=script&setup=true&lang=js"

import "./UserAccountPage.vue?vue&type=style&index=0&id=33984b95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33984b95"]])

export default __exports__